var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTopmenuBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140000830326188122060000013239372036337685676_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9,20.6c0,0.1,0.1,0.2,0.3,0.2c0.1,0,0.2,0,0.3-0.1c0.2-0.2,0.2-0.5,0-0.6l-5.4-5.5l5.4-5.4c0.1-0.1,0.1-0.2,0.1-0.3 s0-0.2-0.1-0.3s-0.2-0.2-0.3-0.2s-0.2,0-0.3,0.1l-6.2,6.2L16.9,20.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopmenuBack);
export default __webpack_public_path__ + "static/media/icon-topmenu-back.3c928c6efa061ff3ae8aec87fbc9b4da.svg";
export { ForwardRef as ReactComponent };